// extracted by mini-css-extract-plugin
export var advbtn = "advisorylightbox-module--advbtn--9d6a4";
export var artistDetailsStyle = "advisorylightbox-module--artistDetailsStyle--ce6e5";
export var artistHeadingStyle = "advisorylightbox-module--artistHeadingStyle--df8d4";
export var border = "advisorylightbox-module--border--e0f4a";
export var closeButton = "advisorylightbox-module--closeButton--265d4";
export var container = "advisorylightbox-module--container--ebae5";
export var heading = "advisorylightbox-module--heading--587b6";
export var iframe = "advisorylightbox-module--iframe--e3322";
export var imgContainerlightBox = "advisorylightbox-module--imgContainerlightBox--fe621";
export var leftColumn = "advisorylightbox-module--leftColumn--5ced2";
export var lightboxContent = "advisorylightbox-module--lightboxContent--235f0";
export var lightboxOpen = "advisorylightbox-module--lightboxOpen--427ce";
export var lightboxOverlay = "advisorylightbox-module--lightboxOverlay--f06c6";
export var paragraph = "advisorylightbox-module--paragraph--b1536";
export var rightColumn = "advisorylightbox-module--rightColumn--e894b";
export var sectionMandatPad = "advisorylightbox-module--sectionMandatPad--9c0bc";
export var title = "advisorylightbox-module--title--fada7";
export var tracked = "advisorylightbox-module--tracked--12489";
export var twoColumnLayout = "advisorylightbox-module--twoColumnLayout--f471e";